var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongZhankaiXia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 7.825A.5.5 0 009.912 7H6.087a.5.5 0 00-.38.825l1.913 2.232a.5.5 0 00.76 0l1.912-2.232z",
    fill: "#3F465C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjI5MjUgNy44MjU0QzEwLjU3MDUgNy41MDEwNiAxMC4zNDAxIDcgOS45MTI4OSA3SDYuMDg3MTFDNS42NTk5MyA3IDUuNDI5NDggNy41MDEwNiA1LjcwNzQ4IDcuODI1NEw3LjYyMDM3IDEwLjA1NzFDNy44MTk5MiAxMC4yODk5IDguMTgwMDggMTAuMjg5OSA4LjM3OTYzIDEwLjA1NzFMMTAuMjkyNSA3LjgyNTRaIiBmaWxsPSIjM0Y0NjVDIi8+Cjwvc3ZnPgo=";
export { SvgTongyongZhankaiXia as ReactComponent };